import Vue from "vue";
import localStorageService from "@/services/localStorage";
import * as types from "./mutation-types";
import api from "@/api";

export const clientIdSuccess = ({ commit }, clientId) => {
  commit(types.CLIENT_ID_SUCCESS, clientId);
  if (Vue.http) {
    Vue.http.headers.common.clientId = `${clientId}`;
  }
  localStorageService.setItem("clientId", clientId);
};

export const clientName = ({ commit }, name) => {
  commit(types.CLIENTNAME, name);
  localStorageService.setItem("clientName", name);
};

// need check if this actions are necessary
export const forgotPasswordSuccessAction = ({ commit }, obj) => {
  commit(types.FORGOT_PASSWORD_SUCCESS, obj);
};
export const forgotPasswordErrorAction = ({ commit }, obj) => {
  commit(types.FORGOT_PASSWORD_ERROR, obj);
};
export const sendOtpSuccessAction = ({ commit }, obj) => {
  commit(types.SEND_OTP_SUCCESS, obj);
};
export const sendOtpErrorAction = ({ commit }, obj) => {
  commit(types.SEND_OTP_ERROR, obj);
};
export const confirmOtpSuccessAction = ({ commit }, obj) => {
  commit(types.CONFIRM_OTP_ERROR, obj);
};
export const confirmOtpErrorAction = ({ commit }, obj) => {
  commit(types.CONFIRM_OTP_SUCCESS, obj);
};
export const addStudyAction = ({ commit }, obj) => {
  commit(types.ADD_STUDY, obj);
};
export const addQuestionAction = ({ commit }, obj) => {
  commit(types.ADD_QUESTION, obj);
};
export const selectedQuestionAction = ({ commit }, obj) => {
  commit(types.SELECTED_QUESTION, obj);
};
export const setSurveyDetailsAction = ({ commit }, obj) => {
  commit(types.SURVEY_DETAILS, obj);
};
export const selectedFeaturesAction = ({ commit }, obj) => {
  commit(types.SELECTED_FEATURES, obj);
};
export const addConsentSectionAction = ({ commit }, obj) => {
  commit(types.ADD_CONSENT_SECTION, obj);
};

export const addOptionalConsentSectionAction = ({ commit }, obj) => {
  commit(types.ADD_OPTIONAL_CONSENT_SECTION, obj);
};

export const addConsentQuizAction = ({ commit }, obj) => {
  commit(types.ADD_CONSENT_QUIZ, obj);
};
export const addOptionalConsentQuizAction = ({ commit }, obj) => {
  commit(types.ADD_OPTIONAL_CONSENT_QUIZ, obj);
};
export const updateProfileDataAction = ({ commit }, obj) => {
  commit(types.UPDATE_PROFILE, obj);
};
export const addSchedule = ({ commit }, obj) => {
  commit(types.ADD_SCHEDULE, obj);
};
export const surveyQuestionsAction = ({ commit }, obj) => {
  commit(types.SURVEY_QUESTIONS, obj);
};
export const setSignatureStatusAction = ({ commit }, obj) => {
  commit(types.SIGNATURE_STATUS, obj);
};
export const setSignatureAction = ({ commit }, obj) => {
  commit(types.SAVE_SIGNATURE, obj);
};
export const telehealthVisitAction = ({ commit }, obj) => {
  commit(types.TELEHEALTH_VISIT, obj);
};
export const setVideoCallStatusAction = ({ commit }, value) => {
  commit(types.VIDEO_CALL_STATUS, value);
};
export const setTelehealthAppointmentDuration = ({ commit }, value) => {
  commit(types.TELEHEALTH_APPOINTMENT_DURATION, value);
};

export const setStaticURL = ({ commit }, value) => {
  commit(types.STATIC_URL, value);
};

export const setIsPublishDisabled = ({ commit }, value) => {
  commit(types.IS_PUBLISH_DISABLED, value);
};

export const setIsPreviewDisabled = ({ commit }, value) => {
  commit(types.IS_PREVIEW_DISABLED, value);
};

export const setRwebPreviewDisabled = ({ commit }, value) => {
  commit(types.IS_RWEB_PREVIEW_DISABLED, value);
};

export const setPublishTab = ({ commit }, value) => {
  commit(types.SET_PUBLISH_TAB, value);
};

export const setActivityRowsAction = ({ commit }, obj) => {
  commit(types.ACTIVITY_ROWS, obj);
};
export const setActivityDetailsAction = ({ commit }, obj) => {
  commit(types.ACTIVITY_DETAILS, obj);
};
export const activityQuestionsAction = ({ commit }, obj) => {
  commit(types.ACTIVITY_QUESTIONS, obj);
};
export const addActivityQuestionAction = ({ commit }, obj) => {
  commit(types.ADD_ACTIVITY_QUESTION, obj);
};
export const selectedActivityQuestionAction = ({ commit }, obj) => {
  commit(types.SELECTED_ACTIVITY_QUESTION, obj);
};
export const setLastModifiedActivityQuestion = ({ commit }, obj) => {
  commit(types.SET_LAST_MODIFIED_ACTIVITY_QUESTION, obj);
};
export const setBase64SignatureAction = ({ commit }, obj) => {
  commit(types.SAVE_BASE_64_SIGNATURE, obj);
};

export const setBase64InitialAction = ({ commit }, obj) => {
  commit(types.SAVE_BASE_64_INITIAL, obj);
};

/** Participants Portal - START */
export const setParticipantsGlobalElements = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_GLOBAL_ELEMENTS, obj);
};

export const setParticipantsConfigs = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_CONFIG, obj);
};

export const setParticipantsPortalLanguages = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_LANGUAGES, obj);
};

export const setParticipantsPortalLanguageTranslation = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_LANGUAGE_TRANSLATION, obj);
};

export const setParticipantsPortalStrings = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_STRINGS, obj);
};

export const setParticipantsPortalBitriseData = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_BITRISE_DATA, obj);
};

export const setParticipantsPortalStudyData = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_STUDY_DATA, obj);
};

export const setParticipantSelectedActivity = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_SELECTED_ACTIVITY, obj);
};

export const setParticipantAdherences = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_ADHERENCES, obj);
};

export const setParticipantTaskSchedules = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_TASK_SCHEDULES, obj);
};

export const setParticipantStudyTaskSchedules = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_STUDY_TASK_SCHEDULES, obj);
};

export const setParticipantLanguages = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_LANGUAGES, obj);
};

export const setParticipantCountries = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_COUNTRIES, obj);
};

export const setParticipantsPortalConsentData = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_CONSENT_DATA, obj);
};

export const setParticipantsDetails = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_PORTAL_DETAILS, obj);
};

export const setParticipantsTelehealthSession = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_TELEHEALTH_VIDOCALL_DETAILS, obj);
};

export const setParticipantsAppointmentStatus = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_APPOINTMENT_STATUS, obj);
};

export const loadParticipantWebVideosToStore = ({ commit }, studyId) => {
  let videos = null;
  api
    .getParticipantVideos(studyId, 0)
    .then(res => {
      videos = Object.keys(res.body.participantVideos).length === 0 ? null : res.body.participantVideos;
      commit(types.PARTICIPANTS_STUDY_VIDEOS, videos);
    })
    .catch(() => {
      commit(types.PARTICIPANTS_STUDY_VIDEOS, videos);
    });
};
export const setParticipantsActivityTranslation = ({ commit }, obj) => {
  commit(types.PARTICIPANTS_ACTIVITY_TRANSLATION, obj);
};
export const setSelectedActivity = ({ commit }, obj) => {
  commit(types.SELECTED_ACTIVITY, obj);
};
/** Participants Portal - END */

export const setAwsAuthenticationFlow = ({ commit }, value) => {
  commit(types.AWS_COGNITO_AUTHENTICATION, value);
  localStorageService.setItem("awsCognitoAuthentication", value);
};

export const setPWEBCognitoFlag = ({ commit }, value) => {
  commit(types.PWEB_COGNITO_AUTHENTICATION, value);
  localStorageService.setItem("pwebCognitoAuthentication", value);
};

export const setCSSRActivityLanguages = ({ commit }, obj) => {
  commit(types.CSSR_ACTIVTY_LANGUAGE, obj);
};
export const setSSOLoginURL = ({ commit }, value) => {
  commit(types.SSO_LOGIN_URL, value);
};

export const setSSOPoolClient = ({ commit }, value) => {
  commit(types.SSO_POOL_CLIENT, value);
};
/** Dynamic Activity Scheduling - Start */
export const setConstantDynamicActivitySchedules = ({ commit }, obj) => {
  commit(types.STORE_CONSTANT_DYNAMIC_ACTIVITY_SCHEDULES, obj);
};

export const setDynamicActivitySchedules = ({ commit }, obj) => {
  commit(types.STORE_DYNAMIC_ACTIVITY_SCHEDULES, obj);
};

export const setDynamicActivityScheduleForEditing = ({ commit }, obj) => {
  commit(types.EDIT_SELECTED_DYNAMIC_ACTIVITY_SCHEDULE, obj);
};

export const setConfiguredTriggersData = ({ commit }, obj) => {
  commit(types.DYNAMIC_SCHEDULE_CONFIGURED_TRIGGERS_DATA, obj);
};

export const setConfiguredActionsData = ({ commit }, obj) => {
  commit(types.DYNAMIC_SCHEDULE_CONFIGURED_ACTIONS_DATA, obj);
};

export const setDynamicSchedulingServiceData = ({ commit }, obj) => {
  commit(types.DYNAMIC_SCHEDULING_SERVICE, obj);
};
/** Dynamic Activity Scheduling - End */

export const setDateRangeView = ({ commit }, value) => {
  commit(types.DATE_RANGE_VIEW_ENABLED, value);
};
export const setStudyToggledFeaturesData = ({ commit }, obj) => {
  commit(types.STUDY_TOGGLED_FEATURES, obj);
};
export const setmultiFactorEnableFlag = ({ commit }, value) => {
  commit(types.MULTI_FACTOR_AUTH_ENABLED, value);
  localStorageService.setItem("multiFactorAuthEnabled", value);
};
export const setSiteDetailsData = ({ commit }, value) => {
  commit(types.SITE_DETAILS_DATA, value);
};

export const setWebSocketServiceData = ({ commit }, obj) => {
  commit(types.WEB_SOCKET_SERVICE_DATA, obj);
};
